import React from 'react';
import { connect } from 'react-redux';
import { Container, Input, Label, FormGroup, Row, Col } from 'reactstrap';
import { Formik, Form } from "formik";
import consts from '../../util/Consts';
import './SideFilter.css';

function SideFilter(props) {

    const InitialValues = {
        status: '',
        firstName: '',
        lastName: '',
        phone: '',
        certificate: '',
        poNumber: '',
        claimNumber: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        invoiceNumber: '',
        authorizationNumber: '',
        storeNumber: '',
        startDate: '',
        endDate: ''
    }

    const onSubmit = (values, { setSubmitting }) => {
        setSubmitting(false);

        let isChanged = true;

        if (JSON.stringify(InitialValues) === JSON.stringify(values)) {
            isChanged = false;
        }

        Object.keys(values).map(k => values[k] = typeof values[k] == 'string' ? values[k].trim() : values[k]);

        let sessionVar = props.screen === "PurchaseOrders" ? consts.sessionVariables.POSideFilterData : consts.sessionVariables.ClaimSideFilterData;
        sessionStorage.setItem(sessionVar, JSON.stringify(values));

        props.onSubmitFilter(values, isChanged);
    }

    const clearForm = resetForm => {
        resetForm();

        let sessionVar = props.screen === "PurchaseOrders" ? consts.sessionVariables.POSideFilterData : consts.sessionVariables.ClaimSideFilterData;
        sessionStorage.setItem(sessionVar, JSON.stringify(InitialValues));

        props.onSubmitFilter(InitialValues, true);
    }

    const NumberOnly = (e, setFieldValue) => {
        let numValue = e.target.value.replace(/\D/g, '');
        setFieldValue(e.target.name, numValue);
    }

    const getInitialValues = () => {
        return InitialValues;
    }

    const { sideFiltervValues, screen, windowHeight, statesList } = props;
    var initialValues = sideFiltervValues || getInitialValues();

    var Options = screen === "PurchaseOrders" ? consts.PoStatusOptions : consts.ClaimStatusOptions;

    return (
        <Container style={{ height: windowHeight, "overflowY": "scroll" }} className="sideFilter pb-3">
            <h4 className="font-main text-white mb-4 pt-3">Refine Results By</h4>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {function (props) {
                    const {
                        values,
                        isSubmitting,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        resetForm,
                        setFieldValue
                    } = props;
                    return (
                        <Form onSubmit={handleSubmit} className="form-details">
                            <FormGroup className="mb-2 padding-Col">
                                <Label for="Pstatus">Status</Label>
                                <div className="form-icon">
                                    <select
                                        value={values.status}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        name="status"
                                        id="Pstatus"
                                        className="form-control"
                                    >
                                        <option value="">Select</option>
                                        {Options && Options.map(status => <option value={status.value}>{status.name}</option>)}
                                    </select>
                                    <span style={{ pointerEvents: "none" }}><img alt="" src={require('../../assets/images/angle.png').default} /></span>
                                </div>
                            </FormGroup>
                            <FormGroup className="mb-2 padding-Col">
                                <Label for="Pfname">First Name</Label>
                                <Input
                                    value={values.firstName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="firstName"
                                    type="text"
                                    id="Pfname"
                                />
                            </FormGroup>
                            <FormGroup className="mb-2 padding-Col">
                                <Label for="Plname">Last Name</Label>
                                <Input
                                    value={values.lastName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="lastName"
                                    type="text"
                                    id="Plname"
                                />
                            </FormGroup>
                            <FormGroup className="mb-2 padding-Col">
                                <Label for="Pphone">Phone</Label>
                                <Input
                                    value={values.phone}
                                    onBlur={handleBlur}
                                    onChange={(e) => NumberOnly(e, setFieldValue)}
                                    name="phone"
                                    type="text"
                                    maxLength={10}
                                    id="Pphone"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <div className="col-6 mb-2 padding-Col">
                                        <Label for="certificate">Certificate#</Label>
                                        <Input
                                            value={values.certificate}
                                            onChange={handleChange}
                                            onBlur={handleBlur} type="text"
                                            name="certificate"
                                            id="certificate"
                                        />
                                    </div>
                                    <div className="col-6 mb-2 padding-Col" >
                                        <Label for="invoiceNumber">Invoice#</Label>
                                        <Input value={values.invoiceNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            name="invoiceNumber"
                                            type="text"
                                            id="invoiceNumber"
                                        />
                                    </div>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <div className="col-6 mb-2 padding-Col">
                                        <Label for="poNumber">PO#</Label>
                                        <Input value={values.poNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            name="poNumber"
                                            type="text"
                                            id="poNumber"
                                        />
                                    </div>
                                    <div className="col-6 mb-2 padding-Col">
                                        <Label for="claimNumber">Claim#</Label>
                                        <Input value={values.claimNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            name="claimNumber"
                                            type="text"
                                            id="claimNumber"
                                        />
                                    </div>
                                </Row>
                            </FormGroup>
                            <FormGroup className="mb-2 padding-Col">
                                <Label for="Paddress">Address</Label>
                                <Input
                                    value={values.address}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="address"
                                    type="text"
                                    id="Paddress"
                                />
                            </FormGroup>
                            <FormGroup className="mb-2 padding-Col">
                                <Label for="Pcity">City</Label>
                                <Input
                                    value={values.city}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="city"
                                    type="text"
                                    id="Pcity"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <div className="col-6 mb-2 padding-Col">
                                        <Label for="Pstate">State</Label>
                                        <div className="form-icon">
                                            <select
                                                value={values.state}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                name="state"
                                                id="Pstate"
                                                className="form-control"
                                            >
                                                <option  value="">Select</option>
                                                {statesList.map(state => <option value={state.stateCode}>{state.stateCode}</option>)}

                                            </select>
                                            <span style={{ pointerEvents: "none" }}><img alt="" src={require('../../assets/images/angle.png').default} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-6 mb-2 padding-Col">
                                        <Label for="Pzip">Zip</Label>
                                        <Input value={values.zip}
                                            onChange={(e) => NumberOnly(e, setFieldValue)}
                                            maxLength={5}
                                            onBlur={handleBlur}
                                            name="zip"
                                            type="text"
                                            id="Pzip"
                                        />
                                    </div>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <div className="col-6 mb-2 padding-Col">
                                        <Label for="PauthorizeNo">Authorization#</Label>
                                        <Input
                                            value={values.authorizationNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            name="authorizationNumber"
                                            type="text"
                                            id="PauthorizeNo"
                                        />
                                    </div>
                                    <div className="col-6 mb-2 padding-Col">
                                        <Label for="locStore">Store#</Label>
                                        <Input
                                            value={values.locStore}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            name="locStore"
                                            type="text"
                                            id="locStore"
                                        />
                                    </div>
                                </Row>
                            </FormGroup>

                            <Row>
                                <Col md={6} className="mt-1 padding-Col">
                                    <button disabled={isSubmitting} type="submit" className="btn-web">Search</button>
                                </Col>
                                <Col md={6} className="mt-1 padding-Col">
                                    <button disabled={isSubmitting} onClick={() => clearForm(resetForm)} type="button" className="btn-grey">Clear</button>
                                </Col>
                            </Row>

                        </Form>
                    );
                }.bind(this)}
            </Formik>
        </Container>
    )
}

var SideFilterModule = connect(null)(SideFilter);
export default SideFilterModule;